import {CustomizacaoSubmenuEnum} from 'src/app/shared/enums/CustomizacaoSubmenuEnum';
import {Component, Input, DoCheck, OnInit, SimpleChanges} from '@angular/core';
import {PerfilService} from 'src/app/services/perfil.service';
import {Auth} from 'src/app/models/auth';
import {Perfil} from 'src/app/models/perfil';
import {ApiError} from 'src/app/shared/enums/api-error.enum';
import {AuthenticationService} from 'src/app/services/authentication.service';

import {AcessoRapido} from 'src/app/models/acesso-rapido';
import {PerfilNormalizado} from 'src/app/shared/enums/perfil-normalizado.enum';
import {AcessoRapidoService} from 'src/app/services/acesso-rapido.service';
import {ParametrosDataService} from 'src/app/services/parametros-data.service';
import {NewAlertService} from 'src/app/shared/components/new-alert/new-alert.service';
import {Router} from '@angular/router';
import {TutorialProgresso} from '../../../../models/tutorial';
import {PassosTutorial} from '../../../../shared/enums/passosTutorial.enum';
import { TutorialService } from 'src/app/services/tutorial.service';
import { window } from 'rxjs/operators';
import { ResponseBase } from 'src/app/models/response-base';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupService } from 'src/app/services/group/group.service';


class BtnAcesso {
    btnName: string;
    imgSrc: string;
    tourAnchor: string;
    action: string;
}

@Component({
    selector: 'app-acesso-rapido',
    templateUrl: './acesso-rapido.component.html',
    styleUrls: ['./acesso-rapido.component.css']
})
export class AcessoRapidoComponent implements OnInit, DoCheck {

    private currentUser: Auth;
    private perfis: Perfil[];
    private perfisNormalizado: PerfilNormalizado[] = [];
    public acessosRapidos: AcessoRapido[] = [];
    public auxProgresso = -1;

    @Input() progresso: TutorialProgresso;

    public btnAcessoRapido: BtnAcesso[] = [

        {
            btnName: 'Criar Grupo Flex',
            imgSrc: './assets/icons/grupos/nome_grupo_roxo.svg',
            tourAnchor: '6',
            action: 'novoGrupoFlex'
        },
        {
            btnName: 'Cadastrar Favorecido',
            imgSrc: './assets/icons/acesso-rapido/colaborador.svg',
            tourAnchor: '3',
            action: 'novoColaborador'
        },
        {
            btnName: 'Nova Recarga',
            imgSrc: './assets/icons/acesso-rapido/pedido.svg',
            tourAnchor: '5',
            action: 'novaRecarga'
        },
        {
            btnName: 'Aderir Novos Produtos',
            imgSrc: './assets/icons/acesso-rapido/beneficio.svg',
            tourAnchor: '2',
            action: 'novoBeneficio'
        }
    ];

    constructor(
        private acessoRapidoService: AcessoRapidoService,
        private perfilService: PerfilService,
        private authenticationService: AuthenticationService,
        private alertService: NewAlertService,
        private tutorialService: TutorialService,
        private parametrosDataService: ParametrosDataService,
        private router: Router,
        private groupService: GroupService,
        private modalService: NgbModal
    ) {
    }


    ngOnInit() {
        this.currentUser = this.authenticationService.currentUserValue;
        this.acessoRapidoService.currentAcessosRapidos.subscribe(response => {
            this.acessosRapidos = response;

            this.acessosRapidos = this.acessosRapidos.filter((x, pos) => {
                if (
                    x.url === '/portal/centrocusto' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.centroCusto)
                ) {
                    return false;
                }
                if (
                    x.url === '/portal/colaborador' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.colaborador)
                ) {
                    return false;
                }
                if (
                    x.url === '/portal/unidade' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.unidades)
                ) {
                    return false;
                }
                if (
                    x.url === '/portal/departamento' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.departamentos)
                ) {
                    return false;
                }
                if (
                    x.url === '/portal/dadobancario' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.dadosBancarios)
                ) {
                    return false;
                }
                if (
                    x.url === '/portal/dadoempresa' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.dadosEmpresa)
                ) {
                    return false;
                }
                if (x.url === '/portal/minhasrecargas' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.minhasCompras)
                ) {
                    return false;
                }
                if (x.url === '/portal/novarecarga/create' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.novaCompra)
                ) {
                    return false;
                }
                if (x.url === '/portal/novobeneficio/contratar' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.contratarNovoBeneficio)
                ) {
                    return false;
                }
                if (x.url === '/portal/contrato/contratos' &&
                    !this.ShowSubmenu(CustomizacaoSubmenuEnum.produtosAderidos)
                ) {
                    return false;
                }
                return this.acessosRapidos.indexOf(x) === pos;
            });
        });

        if (this.acessosRapidos.length <= 0) {
            this.perfilService
                .getAll(
                    this.currentUser.token.userReferenceId,
                    this.currentUser.token.assignorGuid
                )
                .subscribe(
                    response => {
                        if (response.status === ApiError.Sucesso) {
                            this.perfis = response.result;
                            this.perfis.forEach(obj => {
                                this.perfisNormalizado.push(
                                    Perfil.parseToPerfilNormalizado(
                                        obj.nomeNormalizado
                                    )
                                );
                            });
                            this.acessosRapidos = AcessoRapido.init(
                                this.perfisNormalizado,
                                6
                            );
                            this.acessoRapidoService.changeAcessosRapidos(
                                this.acessosRapidos
                            );
                        } else {
                            this.alertService.error(response.message);
                        }
                    },
                    error => {
                        this.alertService.error(error.error);
                    }
                );
        }
    }


    ngDoCheck() {
        if (this.progresso) {
            /*if (this.progresso.progresso === undefined) {
                this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente')
                .subscribe((resp: ResponseBase<TutorialProgresso>) => {
                    if (resp.status === ApiError.Sucesso) {
                        this.progresso = resp.result;

                    }
                }, error => {
                    console.log(error);
                });

            }*/
            if (this.progresso.progresso < 100) {
                if (this.tutorialService.getLocalStoragePassoAtual) {
                    switch (this.tutorialService.getLocalStoragePassoAtual.id) {
                        case -1:
                            this.progresso.progresso = 20;
                            break;
                        case 1:
                            this.progresso.progresso = (this.tutorialService.getLocalStoragePassoAtual.id + 1) * 20;
                            break;
                        default:
                           break;

                    }

                }
                if (this.progresso.progresso !== this.auxProgresso ) {
                    this.auxProgresso = this.progresso.progresso;
                    this.getPasso(this.progresso.progresso);
                }

            }
        }
    }

    ShowSubmenu(submenuEnum: CustomizacaoSubmenuEnum) {
        return this.parametrosDataService.ShowSubmenu(submenuEnum);
    }

    showModalFinalizar(content: any) {
        this.modalService.open(content, { centered: true, size: 'lg' });
    }


    private getPasso(progresso: number) {
        switch (progresso) {
            case 0:
                this.changeMenu(PassosTutorial.aderirBeneficio, this.progresso, this.btnAcessoRapido);
                break;
            case 20:
                this.changeMenu(PassosTutorial.aderirBeneficio, this.progresso, this.btnAcessoRapido);
                break;
            case 40:
                this.changeMenu(PassosTutorial.aderirBeneficio, this.progresso, this.btnAcessoRapido);
                break;
            case 60:
                this.changeMenu(PassosTutorial.cadastrarColaborador, this.progresso, this.btnAcessoRapido);
                break;
            case 80:
                this.changeMenu(PassosTutorial.cadastrarPedido, this.progresso, this.btnAcessoRapido);
                break;
            default:
                this.changeMenu(PassosTutorial.concluido, this.progresso, this.btnAcessoRapido);
                break;
        }
    }

    changeMenu(passoTutorial: PassosTutorial, progresso: TutorialProgresso, btnAcessoRapido: BtnAcesso[]) {
        if (passoTutorial !== PassosTutorial.concluido) {
            const newBtnAcesso: BtnAcesso[] = [];
            const btn = btnAcessoRapido.find(f => f.tourAnchor === passoTutorial.toString());
            if (btn) {
                newBtnAcesso.push(btn);
            }

            this.btnAcessoRapido = this.btnAcessoRapido.filter(f => f.tourAnchor !== passoTutorial.toString());
            if (passoTutorial === PassosTutorial.aderirBeneficio) {
                this.btnAcessoRapido = this.changePosition(this.btnAcessoRapido, 0, 1);
            }
            newBtnAcesso.push(...this.btnAcessoRapido);

            this.btnAcessoRapido = newBtnAcesso;
        }
    }

    public changePosition(arr, from, to): [] {
        arr.splice(to, 0, arr.splice(from, 1)[0]);
        return arr;
    }


    actionRouter(action: string) {
        switch (action) {
            case 'novaRecarga':
                this.novaRecarga();
                break;
            case 'novoColaborador':
                this.novoColaborador();
                break;
            case 'novoBeneficio':
                this.novoBeneficio();
                break;
            case 'novoGrupoFlex':
                this.novoGrupoFlex();
                break;
            default:
                console.log('Erro ao encontrar rota');
                break;
        }

    }

    novoGrupoFlex() {
        this.groupService.clearRascunho();
        this.router.navigate(['portal/grupos/create']);
    }

    novaRecarga() {
        this.router.navigate(['portal/novarecarga/create']);
    }

    novoColaborador() {
        this.router.navigate(['portal/colaborador/create']);
    }

    novoBeneficio() {
        this.router.navigate(['portal/novobeneficio/contratar']);
    }

    terminarTutorial(modal: any) {
        this.tutorialService.getProgresso(this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, 'homeCedente').subscribe((resp: ResponseBase<TutorialProgresso>) => {
            if (resp.status === ApiError.Sucesso) {
                /* console.log(resp.result) */

                this.progresso.ativo = resp.result.ativo;
                this.progresso.ordemAtividade = 5;
                this.progresso.idCedente = this.currentUser.token.assignorGuid;
                this.progresso.idGestor = this.currentUser.token.userReferenceId;
                this.progresso.nomeTutorial = 'homeCedente';
                this.tutorialService.updateProgresso(this.progresso).subscribe(r => {
                    /* console.log(r) */

                });
            }
        }, error => {
            console.log(error);
        });
        this.progresso.progresso = 100;
    }


}
